<script>
import { canEditAttendanceMoneyFields } from "@/helpers/userPermissions"
import { resolveCodeTaxId } from "@/helpers/attendance-code-tax"
import { notificationMethods } from "@/state/helpers"
import { required } from "vuelidate/lib/validators"
import { Multiselect } from "vue-multiselect"
export default {
  props: {
    currentUser: { type: Object, required: true },
    currentEmpresa: {type: Object, required: true},
    currentAtendimento: { type: Object },
    listAgreements: { type: Array },
    listApproachs: { type: Array },
    listCodestaxs: { type: Array, required: true },
    listPacients: { type: Array },
    listPrices: { type: Array, required: true },
    listProfessionals: { type: Array },
    listSpecialties: { type: Array },
    tiposPagamento: { type: Array }
  },
  components: { Multiselect },
  data() {
    return {
      agreements: [],
      responsaveis: [],
      abordagens: [],
      tratamentos: [],
      pacientes: [],
      profissionais: [],
      codestax:[],
      tiposDePagamento: [],
      loader: {
        get: false,
      },
      items: [
        {
          text: "Dashboard",
          href: "/",
        },
        {
          text: "Atendimentos",
          href: "/atendimentos",
          active: true,
        },
      ],
      titleBody: "Alterando",
      inserindo: true,
      submitted: false,
      service: {
        service_value: 0,
        transfer_amount: 0,
        coparticipation_amount: 0,
        tipo_pagamento: null,
        tipo_pagamento_id: null,
        pacient: null,
        pacient_id: null,
        professional: null,
        agreement_id: null, // convêcnio (Unimed, SulAmerica)
        start_date: null,
        start_time: null,
        end_date: null,
        end_time: null,
        recurrence: null,
        responsible_id: null,
        contact: null,
        treatment: null,
        approach: null,
        local: null,
      },
      listRecurrence: [
        { id: 1, type: "none", name: "Nunca" },
        // { id: 2, type: "DAILY", name: "Diário" },
        { id: 3, type: "WEEKLY", name: "Semanal" },
        // { id: 4, type: "MONTHLY", name: "Mensal" },
        // { id: 4, type: "YEARLY", name: "Anual" },
      ],
      selectedTratament: null,
      selectedAgreement: null,
      selectedTipoPagamento: null,
    }
  },
  created() {
    this.agreements       = this.listAgreements
    this.abordagens       = this.listApproachs
    this.codestax         = this.listCodestaxs
    this.pacientes        = this.listPacients
    this.prices           = this.listPrices
    this.profissionais    = this.listProfessionals
    this.responsaveis     = this.listResponsibles
    this.tratamentos      = this.listSpecialties
    this.service          = this.currentAtendimento
    this.tiposDePagamento = this.tiposPagamento
    this.service.transfer_amount = this.service.transfer_amount || 0
  },
  validations() {
    return {
      service: {
        pacient: { required },
        professional: { required },
        agreement_id: { required },
        service_value: { required },
        day: { required },
        hour: { required },
        responsable_id: { required },
        contact: { required },
        treatment: { required },
        approach: { required },
        local: { required },
      },
    }
  },
  mounted() {
    this.$emit("newTitle", "Alterando Atendimento")
    this.service.service_value          = this.formatterFloatBR(this.service.service_value, 2)
    this.service.transfer_amount        = this.formatterFloatBR(this.service.transfer_amount || 0, 2)
    this.service.coparticipation_amount = this.formatterFloatBR(this.service.coparticipation_amount, 2)
    this.service.specialty_id = this.service.treatment_id
    this.service.specialty = this.service.treatment? this.service.treatment : null

    this.selectedTratament = this.tratamentos.find((item) => {
      return item.id == this.service.treatment_id
    })
    this.selectedTipoPagamento = this.tiposDePagamento.find((item) => {
      return item.id == this.service.tipo_pagamento_id
    })
    this.syncSelectedAgreement()
  },
  computed: {
    permission() {
      return canEditAttendanceMoneyFields(this.currentUser)
    },
    isPrivate() {
      return this.service.pacient ? this.service.pacient.is_private : null
    },
    notification() {
      return this.$store ? this.$store.state.notification : null
    },
    getCidadeId(objects, key) {
      return objects.map(function (object) {
        return object[key]
      })
    },
  },
  watch: {
    listAgreements: {
      immediate: true,
      handler(newAgreements) {
        this.agreements = Array.isArray(newAgreements) ? newAgreements : []
        this.syncSelectedAgreement()
      },
    },
    currentAtendimento: {
      immediate: true,
      handler(newAtendimento) {
        if (!newAtendimento) {
          return
        }

        console.log("currentAtendimento", newAtendimento)
        this.service = Object.assign({}, this.service, newAtendimento)
        this.syncSelectedAgreement()
      },
    },
  },
  methods: {
    ...notificationMethods,
    makeToast(variant = null, message = "Error generic") {
      this.counter++
      this.$bvToast.toast(message, {
        title: `Notificação`,
        toaster: "b-toaster-bottom-right",
        variant: variant,
        solid: true,
        appendToast: true,
      })
    },
    setPut() {
      this.service.service_value = this.new_convert_srting_float(
        this.service.service_value
      )
      this.service.transfer_amount = this.new_convert_srting_float(
        this.service.transfer_amount
      )
      this.service.coparticipation_amount = this.new_convert_srting_float(
        this.service.coparticipation_amount
      )
      this.$emit("doPut", this.service)
    },
    onPacientSelected(event) {
      console.log(event)
    },
    onProfessionalSelected(event) {
      console.log(event)
    },
    onTipoPagamentoSelecionado(tipoPagamento) {
      // Verificação de segurança + atribuição limpa
      this.service.tipo_pagamento_id = tipoPagamento?.id || null
      this.service.tipo_pagamento    = tipoPagamento
    },
    onTratamentSelected(tratament) {
      this.service.treatment_id = tratament?.id || null
      this.service.treatment = tratament? tratament : null
      this.service.specialty_id = this.service.treatment_id
      this.service.specialty = this.service.treatment
      this.applyCodeTaxFromSelections()
      this.setPrice()
    },
    onApproachSelected(approach) {
      this.service.approach_id = approach?.id || null
      this.setPrice();
    },
    onAgreementSelected(agreement) {
      this.service.agreement_id = agreement?.id || null
      this.selectedAgreement = agreement || null
      this.applyCodeTaxFromSelections()
      this.setPrice()
    },
    applyCodeTaxFromSelections() {
      this.service.code_tax_id = resolveCodeTaxId({
        agreement: this.selectedAgreement,
        specialty: this.service.treatment || this.service.specialty,
      })
    },
    syncSelectedAgreement() {
      const agreementId = this.service?.agreement_id || this.service?.agreement?.id

      if (!agreementId) {
        this.selectedAgreement = null
        return
      }

      const agreement = this.agreements.find((item) => {
        return String(item.id) === String(agreementId)
      })

      this.selectedAgreement = agreement || null
      this.service.agreement_id = this.selectedAgreement?.id || null
      this.applyCodeTaxFromSelections()
    },
    // eslint-disable-next-line no-unused-vars
    formSubmit(e) {
      this.submitted = true
      this.setPut()
    },
    back() {
      this.$emit("back")
    },
    changeLoader(value) {
      this.loader.get = value
    },
    setPrice() {
      // Aplicar o preço filtrando tratamento e convênio
      console.log(this.service)
      if (this.service?.specialty_id && this.service?.agreement_id) {
        let price = this.listPrices?.filter((item) => {
          return (
            item.specialty_id == this.service.specialty_id &&
            item.agreement_id == this.service.agreement_id
          )
        })

        if (price.length > 0) {
          this.service.service_value   = this.formatterFloatBR(price[0].service_value)
          this.service.transfer_amount = this.formatterFloatBR(price[0].transfer_amount)
        } else {
          this.service.service_value   = this.formatterFloatBR(0)
          this.service.transfer_amount = this.formatterFloatBR(0)
        }
      }
    },
  },
}
</script>

<template>
  <div class="row">
    <div class="col-md-12">
      <form @submit.prevent="formSubmit" name="formAtendimento">
        <div class="form-row">
          <div class="form-group col-md2">
            <label for="service_id">Código (ID):</label>
            <b-input id="service_id" type="text" placeholder="Código" :value="service.id" disabled class="text-right"></b-input>
          </div>
        </div>
        <div class="form-row mt-4">
          <div class="form-group col-md-4">
            <label for="nome">Paciente:</label>
            <select
              @change="onPacientSelected($event)"
              class="custom-select mr-sm-2"
              id="selectProfessional"
              v-model="service.pacient_id"
              disabled
            >
              <option value="-1" selected="selected">
                Selecione o Paciente
              </option>
              <option
                v-for="(item, index) in pacientes"
                :key="index"
                :value="item.id"
              >
                {{ item.nome }}
              </option>
            </select>
          </div>
          <div class="form-group col-md-4">
            <label for="agreement_id">Convênio:</label>
            <Multiselect 
              v-model="selectedAgreement"
              :options="agreements"
              :multiple="false"
              :disabled="true"
              :close-on-select="true"
              :preserve-search="true"
              :show-labels="true"
              :select-label="''"
              :deselect-label="''"
              placeholder="Selecione o convênio"
              label="name"
              track-by="id"
              @input="onAgreementSelected">
            </Multiselect>
          </div>
          <div class="form-group col-md-3">
            <label for="selectAtendimentoProfessional">Profissional:</label>
            <select
              @change="onProfessionalSelected($event)"
              class="custom-select mr-sm-2"
              id="selectProfessional"
              v-model="service.professional_id"
              disabled
            >
              <option value="-1" selected="selected">
                Selecione o profissional
              </option>
              <option
                v-for="(item, index) in profissionais"
                :key="index"
                :value="item.id"
              >
                {{ item.name }}
              </option>
            </select>
          </div>
        </div>
        <div class="form-row mt-4">
          <div class="form-group col-md-6">
            <label for="selectAtendimentoTreatment">Tratamento:</label>
            <Multiselect
              v-model="selectedTratament"
              :options="tratamentos"
              :multiple="false"
              :close-on-select="true"
              :clear-on-select="true"
              :preserve-search="true"
              :show-labels="false"
              placeholder="Selecione o tratamento"
              label="name"
              track-by="id"
              @input="onTratamentSelected"
            >
            </Multiselect>
          </div>
          <div class="form-group col-md-6">
            <label for="selectAtendimentoApproach">Abordagem:</label>
            <select
              class="custom-select mr-sm-2"
              id="selectApproach"
              v-model="service.approach_id"
              @input="onApproachSelected"
            >
              <option value="-1" selected="selected">
                Selecione a abordagem
              </option>
              <option
                v-for="(item, index) in abordagens"
                :key="index"
                :value="item.id"
              >
                {{ item.name }}
              </option>
            </select>
          </div>
        </div>
        <div class="form-row mt-4">
          <div class="form-group col-md-4">
            <label for="code_tax_id">Código Fiscal do Serviço:</label>
            <select
              v-model="service.code_tax_id"
              class="form-control"
              id="code_tax_id"
            >
              <option
                v-for="codetax in codestax"
                :key="codetax.id"
                :value="codetax.id"
              >
              {{ codetax.id }} - {{ codetax.name }}
              </option>
            </select>
          </div>
          <div class="form-group col-md-2">
            <label for="localAtendimento">Local do atendimento:</label>
            <input
              id="localatendimento"
              type="text"
              class="form-control"
              placeholder="Local de atendimento"
              v-model="service.local"
            />
          </div>
          <div class="form-group col-md-2" v-show="permission || isPrivate">
            <label for="service_value">Valor do atendimento:</label>
            <input
              id="service_value"
              type="text"
              class="form-control text-right"
              placeholder="Ex: 70"
              v-model="service.service_value"
              @input="formatInputFloat($event, service, 'service_value')"
            />
          </div>
          <div class="form-group col-md-2" v-show="permission || isPrivate">
            <label for="coparticipation_amount">Valor Coparticipação:</label>
            <input
              id="coparticipation_amount"
              type="text"
              class="form-control text-right"
              placeholder="Ex: 70"
              v-model="service.coparticipation_amount"
              @input="formatInputFloat($event, service, 'coparticipation_amount')"
            />
          </div>
          <div class="form-group col-md-2" v-show="permission">
            <label for="transfer_amount">Valor do repasse:</label>
            <input
              id="transfer_amount"
              type="text"
              class="form-control text-right"
              placeholder="Ex: 70"
              v-model="service.transfer_amount"
              @input="formatInputFloat($event, service, 'transfer_amount')"
            />
          </div>
        </div>

        <div class="form-row mt-4" v-if="isPrivate">
          <div class="col-md-4">
            <label for="tipo_pagamento_id">Tipo Pagamento</label>
            <Multiselect
              :options="tiposDePagamento"
              v-model="selectedTipoPagamento"
              @input="onTipoPagamentoSelecionado"
              :multiple="false"
              :close-on-select="true"
              :clear-on-select="true"
              :track-by="'id'"
              :label="'tiponome'"
              deselect-label="ENTER para remover"
              select-label="Enter para selecionar"
              placeholder="Selecione"
            ></Multiselect>
          </div>
        </div>

        <div class="form-row mt-4">
          <div class="col-md-12 mt-4">
            <button
              type="button"
              class="btn btn-warning"
              style="margin-right: 20px"
              @click="back()"
            >
              <i class="ri-close-line align-middle mr-2"></i> Cancelar
            </button>
            <button
              type="submit"
              class="btn btn-success"
              style="margin-right: 20px"
              @click.prevent="setPut()"
            >
              <i class="ri-check-line align-middle mr-2"></i> Gravar
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>